import { OMKRequestError } from '../errors/OMK';
import { EIRCRequestError } from '../errors/EIRC';

/**
 * @typedef {{super_short: string, short: string, full: string, districts: DistrictName[]}} Area
 */

export type AreaDistricts = [];

export type District = string;

export interface Area {
  super_short: string;
  short: string;
  full: string;
  districts: District[];
}

/**
 * @typedef {string} DistrictName
 */

/**
 * @typedef {{text: DistrictName, value: string, areaId: Area.short}} District
 */

/**
 * Уровень детализации, до которого адрес найден в ФИАС.
 * 1 — уровень регион;
 * 2 - уровень автономного округа (устаревшее);
 * 3 — уровень район;
 * 35 - уровень городских и сельских поселений;
 * 4 — город;
 * 5 - уровень внутригородской территории (устаревшее);
 * 6 — населенный пункт;
 * 65 - планировочная структура;
 * 7 — улица;
 * 75 – земельный участок;
 * 8 — здания, сооружения, объекта незавершенного строительства;
 * 9 – уровень помещения в пределах здания, сооружения;
 * 90 – уровень дополнительных территорий (устаревшее);
 * 91 – уровень объектов на дополнительных территориях (устаревшее);
 */
export const FIAS_LEVEL_HOUSE = 8;
export const FIAS_LEVEL_STREET = 7;
export const FIAS_LEVEL_DISTRICT = 3;
export const FIAS_LEVEL_CITY = 4;

export const ZEL_AO = 'Зеленоградский АО';

/**
 *
 * @type {Area[]}
 */
const areaDistricts: Area[] = [
  {
    super_short: 'ЦАО',
    short: 'Центральный АО',
    full: 'Центральный Административный Округ',
    districts: [
      'Арбат',
      'Басманный',
      'Замоскворечье',
      'Красносельский',
      'Мещанский',
      'Пресненский',
      'Таганский',
      'Тверской',
      'Хамовники',
      'Якиманка',
    ],
  },
  {
    super_short: 'САО',
    short: 'Северный АО',
    full: 'Северный Административный Округ',
    districts: [
      'Аэропорт',
      'Беговой',
      'Бескудниковский',
      'Войковский',
      'Восточное Дегунино',
      'Головинский',
      'Дмитровский',
      'Западное Дегунино',
      'Коптево',
      'Левобережный',
      'Молжаниновский',
      'Савёловский',
      'Сокол',
      'Тимирязевский',
      'Ховрино',
      'Хорошёвский',
    ],
  },
  {
    super_short: 'СВАО',
    short: 'Северо-Восточный АО',
    full: 'Северо-Восточный Административный Округ',
    districts: [
      'Алексеевский',
      'Алтуфьевский',
      'Бабушкинский',
      'Бибирево',
      'Бутырский',
      'Лианозово',
      'Лосиноостровский',
      'Марфино',
      'Марьина Роща',
      'Останкинский',
      'Отрадное',
      'Ростокино',
      'Свиблово',
      'Северное Медведково',
      'Северный',
      'Южное Медведково',
      'Ярославский',
    ],
  },
  {
    super_short: 'ВАО',
    short: 'Восточный АО',
    full: 'Восточный Административный Округ',
    districts: [
      'Богородское',
      'Вешняки',
      'Восточное Измайлово',
      'Восточный',
      'Гольяново',
      'Ивановское',
      'Измайлово',
      'Косино-Ухтомский',
      'Метрогородок',
      'Новогиреево',
      'Новокосино',
      'Перово',
      'Преображенское',
      'Северное Измайлово',
      'Соколиная Гора',
      'Сокольники',
    ],
  },
  {
    super_short: 'ЮВАО',
    short: 'Юго-Восточный АО',
    full: 'Юго-Восточный Административный Округ',
    districts: [
      'Выхино-Жулебино',
      'Капотня',
      'Кузьминки',
      'Лефортово',
      'Люблино',
      'Марьино',
      'Некрасовка',
      'Нижегородский',
      'Печатники',
      'Рязанский',
      'Текстильщики',
      'Южнопортовый',
    ],
  },
  {
    super_short: 'ЮАО',
    short: 'Южный АО',
    full: 'Южный Административный Округ',
    districts: [
      'Бирюлёво Восточное',
      'Бирюлёво Западное',
      'Братеево',
      'Даниловский',
      'Донской',
      'Зябликово',
      'Москворечье-Сабурово',
      'Нагатино-Садовники',
      'Нагатинский затон',
      'Нагорный',
      'Орехово-Борисово Северное',
      'Орехово-Борисово Южное',
      'Царицыно',
      'Чертаново Северное',
      'Чертаново Центральное',
      'Чертаново Южное',
    ],
  },
  {
    super_short: 'ЮЗАО',
    short: 'Юго-Западный АО',
    full: 'Юго-Западный Административный Округ',
    districts: [
      'Академический',
      'Гагаринский',
      'Зюзино',
      'Коньково',
      'Котловка',
      'Ломоносовский',
      'Обручевский',
      'Северное Бутово',
      'Тёплый Стан',
      'Черёмушки',
      'Южное Бутово',
      'Ясенево',
    ],
  },
  {
    super_short: 'ЗАО',
    short: 'Западный АО',
    full: 'Западный Административный Округ',
    districts: [
      'Внуково',
      'Дорогомилово',
      'Крылатское',
      'Кунцево',
      'Можайский',
      'Ново-Переделкино',
      'Очаково-Матвеевское',
      'Проспект Вернадского',
      'Раменки',
      'Солнцево',
      'Тропарево-Никулино',
      'Филёвский Парк',
      'Фили-Давыдково',
    ],
  },
  {
    super_short: 'СЗАО',
    short: 'Северо-Западный АО',
    full: 'Северо-Западный Административный Округ',
    districts: [
      'Куркино',
      'Митино',
      'Покровское-Стрешнево',
      'Северное Тушино',
      'Строгино',
      'Хорошево-Мневники',
      'Щукино',
      'Южное Тушино',
    ],
  },
  {
    super_short: 'ЗелАО',
    short: 'Зеленоградский АО',
    full: 'Зеленоградский Административный Округ',
    districts: ['Крюково', 'Матушкино', 'Савёлки', 'Силино', 'Старое Крюково'],
  },
  {
    super_short: 'ТАО',
    short: 'Троицкий АО',
    full: 'Троицкий Административный Округ',
    districts: [
      'Вороновское',
      'Киевский',
      'Кленовское',
      'Краснопахорское',
      'Михайлово-Ярцевское',
      'Новофёдоровское',
      'Первомайское',
      'Роговское',
      'Городской округ Троицк',
      'Щаповское',
    ],
  },
  {
    super_short: 'НАО',
    short: 'Новомосковский АО',
    full: 'Новомосковский Административный Округ',
    districts: [
      'Внуковское',
      'Воскресенское',
      'Десеновское',
      'Кокошкино',
      'Марушкинское',
      'Московский',
      'Мосрентген',
      'Рязановское',
      'Сосенское',
      'Филимонковское',
      'Городской округ Щербинка',
    ],
  },
];

export const areaSuggestions = areaDistricts.map(({ short: text }, value) => ({
  text,
  value,
}));

export default areaDistricts;

export const isNewMoscowArea = (area) =>
  ['Новомосковский АО', 'Троицкий АО'].includes(area);

export const isSubsequentRequestError = (subsequentRequestError) =>
  [OMKRequestError.errorName, EIRCRequestError.errorName].includes(
    subsequentRequestError
  );

export const ZEL_OMK_STREET_CODE = '08011';

const omkCodesByDistrict = {
  //пока только ЗелАО
  Крюково: {
    omk_area_code: '1000',
    omk_district_code: '1005',
    omk_street_code: ZEL_OMK_STREET_CODE,
  },
  Матушкино: {
    omk_area_code: '1000',
    omk_district_code: '1009',
    omk_street_code: ZEL_OMK_STREET_CODE,
  },
  Савёлки: {
    omk_area_code: '1000',
    omk_district_code: '1010',
    omk_street_code: ZEL_OMK_STREET_CODE,
  },
  Силино: {
    omk_area_code: '1000',
    omk_district_code: '1011',
    omk_street_code: ZEL_OMK_STREET_CODE,
  },
  'Старое Крюково': {
    omk_area_code: '1000',
    omk_district_code: '1012',
    omk_street_code: ZEL_OMK_STREET_CODE,
  },
};

export const getOmkCodesByDistrict = (district) => omkCodesByDistrict[district];

export const ADDRESS_INFO_FIELD_NAME = {
  region: 'region',
  district: 'district',
  area: 'area',
  street: 'street',
  house: 'house',
  structure: 'structure',
  building: 'building',
  flat: 'flat',
};
